import { __extends } from "tslib";
import { ServiceException as __ServiceException, } from "@aws-sdk/smithy-client";
var GandalfLoginAssociationServiceException = (function (_super) {
    __extends(GandalfLoginAssociationServiceException, _super);
    function GandalfLoginAssociationServiceException(options) {
        var _this = _super.call(this, options) || this;
        Object.setPrototypeOf(_this, GandalfLoginAssociationServiceException.prototype);
        return _this;
    }
    return GandalfLoginAssociationServiceException;
}(__ServiceException));
export { GandalfLoginAssociationServiceException };
